import styled, { css } from 'styled-components';
import { Popper } from '@mui/material';

import { ReactComponent as ChatIcon } from '../../../assets/icons/chat-icon.svg';
import Button from '../../../components/Button';
import colors from '../../../styles/colors';

import variants from './variants';

const chatIconPx = 30;

const iconVariant = (variant) => {
  switch (variant) {
    case variants.PRIMARY:
      return css`fill: ${colors.base.secondary3};`;
    case variants.SECONDARY:
      return css`fill: ${colors.base.primary};`;
    default:
      // primary variant by default
      return css`fill: ${colors.shades.secondary7};`;
  }
};

const Container = styled.div`
  display: flex;
  position: relative;
`;

const UnreadBadge = styled.span`
  position: absolute;
  top: -4px;
  right: -4px;
  border-radius: 50%;
  background-color: ${colors.base.danger};
  height: 16px;
  min-width: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
  pointer-events: none;
`;

const UnreadBadgeText = styled.span`
  font-size: 9px;
  font-weight: 700;
  color: ${colors.base.alpha};
  line-height: 1;
`;

const ChatButton = styled(Button)`
  border-radius: 5px;
  column-gap: 8px;
  background: ${colors.base.primary};
  color: ${colors.base.beta};
  height: fit-content;
  padding: 10px 7px;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
  cursor: pointer;

  &:hover {
    background: ${colors.shades.primary6};
  }
`;

const ChatIconButton = styled(Button)`
  background-color: transparent;
  color: ${colors.shades.secondary3};
  border-radius: 50%;
  width: ${chatIconPx}px;
  height: ${chatIconPx}px;
  padding: 5px;
  margin-left: 5px;
  cursor: pointer;

  &:hover {
    background-color: ${colors.shades.gamma1};
  }
`;

const StyledButton = styled(Button)`
  display: flex;
  flex-direction: column;
  background-color: transparent;
  color: ${colors.base.beta};
  text-transform: capitalize;
  font-size: 11px;
  font-weight: 500;
  border-radius: 8px; 
  cursor: pointer;
  padding: 5px 20px;

  &:hover {
    background-color: ${colors.shades.gamma1};
  }
`;

const StyledPopper = styled(Popper)`
  z-index: 99;
`;

const StyledChatLightIcon = styled(ChatIcon)`
  width: 15px;
  height: 15px;
`;

const StyledChatTextIcon = styled(StyledChatLightIcon)`
  width: 24px;
  height: 24px;
  
  > path {
    stroke: ${colors.shades.secondary8};
    stroke-width: 1;
    ${(props) => iconVariant(props?.variant)}
  }
`;

const StyledChatIcon = styled(StyledChatLightIcon)`
  width: 15px;
  height: 15px;

  > path {
    stroke: ${colors.shades.secondary8};
    ${(props) => iconVariant(props?.variant)}
  }
`;

export {
  Container,
  ChatButton,
  ChatIconButton,
  StyledPopper,
  StyledChatIcon,
  StyledChatLightIcon,
  StyledChatTextIcon,
  StyledButton,
  UnreadBadge,
  UnreadBadgeText,
};
